import React from "react";
import icon from "./assets/icon.svg";
import { Container, Icon, Text, TextWrapper, Title } from "./styles";

const ExpiredBillBanner: React.FC = () => {
  return (
    <Container>
      <Icon src={icon} alt="Ícone de informação" />
      <TextWrapper>
        <Title>Este boleto está vencido</Title>
        <Text>
          Juros e taxas serão adicionados e cobrados na próxima fatura.
        </Text>
      </TextWrapper>
    </Container>
  );
};

export default ExpiredBillBanner;
